/**
 *
 */
var ColorUtils = /** @class */ (function () {
    function ColorUtils() {
    }
    ColorUtils.float32ColorToARGB = function (float32Color) {
        var a = (float32Color & 0xff000000) >>> 24;
        var r = (float32Color & 0xff0000) >>> 16;
        var g = (float32Color & 0xff00) >>> 8;
        var b = float32Color & 0xff;
        var result = [a, r, g, b];
        return result;
    };
    ColorUtils.f32_RGBA_To_f32_ARGB = function (float32Color) {
        var r = (float32Color & 0xff000000) >>> 24;
        var g = (float32Color & 0xff0000) >>> 16;
        var b = (float32Color & 0xff00) >>> 8;
        var a = float32Color & 0xff;
        return (a << 24) | (r << 16) | (g << 8) | b;
    };
    ColorUtils.f32_RGB_To_f32_ARGB = function (float32Color) {
        var r = (float32Color & 0xff000000) >>> 24;
        var g = (float32Color & 0xff0000) >>> 16;
        var b = (float32Color & 0xff00) >>> 8;
        var a = float32Color & 0xff;
        return (a << 24) | (r << 16) | (g << 8) | b;
    };
    ColorUtils.prototype.getAlphaFromF32RGBA = function (float32Color) {
        return float32Color & 0xff;
    };
    ColorUtils.ARGBtoFloat32 = function (a, r, g, b) {
        return ((a << 24) | (r << 16) | (g << 8) | b);
    };
    ColorUtils.componentToHex = function (c) {
        var hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    };
    ColorUtils.RGBToHexString = function (argb) {
        return '#' + ColorUtils.componentToHex(argb[1]) +
            ColorUtils.componentToHex(argb[2]) +
            ColorUtils.componentToHex(argb[3]);
    };
    ColorUtils.ARGBToHexString = function (argb) {
        return '#' + ColorUtils.componentToHex(argb[0]) +
            ColorUtils.componentToHex(argb[1]) +
            ColorUtils.componentToHex(argb[2]) +
            ColorUtils.componentToHex(argb[3]);
    };
    ColorUtils.interpolateFloat32Color = function (start, end, ratio) {
        var a = (start & 0xff000000) >>> 24;
        var r = (start & 0xff0000) >>> 16;
        var g = (start & 0xff00) >>> 8;
        var b = start & 0xff;
        var a2 = (end & 0xff000000) >>> 24;
        var r2 = (end & 0xff0000) >>> 16;
        var g2 = (end & 0xff00) >>> 8;
        var b2 = end & 0xff;
        var rs = 1 - ratio;
        var re = ratio;
        return (((a * rs + a2 * re) << 24) |
            ((r * rs + r2 * re) << 16) |
            ((g * rs + g2 * re) << 8) |
            (b * rs + b2 * re));
    };
    return ColorUtils;
}());
export { ColorUtils };
